export type ControlBuild = {
  version: string;
  revision: string;
  shortRevision: string;
  builtAt?: string;
};

export type NodeUpdateState = 'current' | 'stale' | 'unknown';

export function normalizeRevision(value: unknown): string {
  const raw = String(value ?? '').trim().toLowerCase();
  return /^[0-9a-f]{7,40}$/.test(raw) ? raw : '';
}

export function shortRevision(value: unknown): string {
  const rev = normalizeRevision(value);
  return rev ? rev.slice(0, 7) : '';
}

export function sameRevision(left?: string, right?: string): boolean {
  const a = normalizeRevision(left);
  const b = normalizeRevision(right);
  if (!a || !b) return false;
  const n = Math.min(a.length, b.length);
  return n >= 7 && a.slice(0, n) === b.slice(0, n);
}

export function nodeUpdateState(
  control: Pick<ControlBuild, 'revision'> | null | undefined,
  nodeRevision?: string,
): NodeUpdateState {
  if (!normalizeRevision(control?.revision)) return 'unknown';
  if (!normalizeRevision(nodeRevision)) return 'stale';
  return sameRevision(control?.revision, nodeRevision) ? 'current' : 'stale';
}

export function nodeUpdateLabel(state: NodeUpdateState): string {
  if (state === 'current') return 'актуальна';
  if (state === 'stale') return 'не обновлена';
  return 'нет ревизии';
}

export function formatAgentBuild(version?: string, revision?: string): string {
  const sha = shortRevision(revision);
  const ver = String(version ?? '').trim();
  if (sha && ver) return `${ver} · ${sha}`;
  return sha || ver || '—';
}
